import quotation from '@/api/quotation'
import feeType from '@/api/fee-type'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
	branch_id: null,
	feeTypes: [],
	feeSetups: [],
	date_from: moment().add(-1, 'Month').format('DD-MM-YYYY'),
	date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_FEE_TYPE(state, feeType) {
		state.feeTypes = feeType
	},
	SET_DATE_FROM(state, date) {
		state.date_from = date
	},
	SET_DATE_TO(state, date) {
		state.date_to = date
	},
	SET_SHOW_DATA(state, data) {
		state.showData = data
	},
	SET_BRANCH_ID(state, data) {
		state.branch_id = data
	}
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				search: context.state.search,
				date_from: context.state.date_from,
				date_to: context.state.date_to,
				all_branch: Array.isArray(context.state.branch_id)
					? context.state.branch_id.length
						? undefined
						: true
					: true
			},
			attrubutes
		)
		return quotation.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	async find(context, id) {
		if (_.isEmpty(context.state.showData)) {
			let response = await quotation.find(id)
			context.commit('SET_SHOW_DATA', response.data)
		}
	},
	store(context, data) {
		return quotation.store(data)
	},
	destroy(context, id) {
		return quotation.destroy(id)
	},
	formViewModel(context, params) {
		return quotation.formViewModel({ params })
	},
	async getFeeType(context, attrubutes = {}) {
		let response = await feeType.get({ params: attrubutes })
		context.commit('SET_FEE_TYPE', response.data)
	},
	printPDF(context, { id }) {
		return quotation.printPDF(id)
	}
}
